module.exports = __webpack_public_path__ + "img/rateLev_5.81350a4d.svg";